import React from 'react';
import RootWrapper from './RootWrapper';

const wrapRootElement = ({ element }) => <RootWrapper element={element} />;

export default wrapRootElement;
